import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 border border-primary-300 text-primary-700 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
              Vigorbuy Guides &amp; Articles
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Essential Reading for Smart Buyers
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              In-depth guides, comparisons, and tutorials — everything you need to master the Vigorbuy Spreadsheet and shop with confidence.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group block bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:bg-primary-50 cursor-pointer"
              >
                <div className="relative h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-3 py-1 bg-background-50/90 backdrop-blur-sm text-primary-700 rounded-full text-xs font-semibold">
                      {article.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i>
                      Vigorbuy Team
                    </span>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 leading-snug">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                    Read Article
                    <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-200"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}